import { useInfiniteQuery } from '@tanstack/react-query';
import { IAccount, ImpersonationBroker, IPagedCollection } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IAccountsFilterRequest } from '../../../viewmodels/AdminViewModels';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'admin/account/filter';

export function useAdminAccountFilterQuery({
	filter,
	pageSize = 25,
	sort,
	sortBy,
	autocompleteFragment,
	deleted,
	enabled = true,
}: {
	filter: IAccountsFilterRequest;
	pageSize?: number;
	sort?: `asc` | `desc`;
	sortBy?: string;
	autocompleteFragment?: string;
	deleted?: boolean;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		queryKey: [BASE_QUERY_KEY, filter, pageSize, sort, sortBy, autocompleteFragment, deleted],
		queryFn: ({ pageParam }) =>
			userSession.webServiceHelper.callAsync<IPagedCollection<IAccount>>(
				ImpersonationBroker.composeApiUrl({
					urlPath: 'admin/account/filter',
					queryParams: { pageSize, pageToken: pageParam, sort, sortBy, autocompleteFragment, deleted },
				}),
				'POST',
				filter
			),
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
		enabled,
	});
}

export const invalidateAdminAccountFilterQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
